'use strict';

module.exports = require('./http');


//////////////////
// WEBPACK FOOTER
// ./node_modules/cf-util-http/lib/index.js
// module id = 80
// module chunks = 0